import { render, staticRenderFns } from "./ManageQaqc.vue?vue&type=template&id=898c272e"
import script from "./ManageQaqc.vue?vue&type=script&lang=js"
export * from "./ManageQaqc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports